module.exports = __webpack_public_path__ + "img/标准文件4.442f6d6e.png";